
import React, { useEffect, useState, useCallback } from "react";
import {
  Container,
  Box,
  Button,
  Stack,
  Typography,
  Skeleton,
  Card
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";

import BreadcrumbsNav from "../../components/common/BreadCrumbNav";
// import ResidentialGridView from "./ResidentialGridView";
import ResidentialPropertiesCard from "../../components/common/ResidentialPropertiesCard";
import { get_plot_list, get_rental_list } from "../../api/ControllApi";
import FilterDataCard from "../../components/common/FilterDataCard";
import RentalYieldGridView from "./RentalYieldGridView";
import RentalYieldCard from "../../components/common/RentalYieldCard";
import { useSettings } from "../../context/Settings";
import DescriptionNote from "../../components/common/DescriptionNote";

export default function RentalYieldPlot() {
  const { settings } = useSettings();
  const [view, setView] = useState("grid");
  const [yieldplotData, setYieldPlotData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [resp, setResp] = useState([])
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });

  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const fetchGeoPlots = async (filters = {}, page = 1) => {
    setLoading(true);

    try {
      const params = {};

      // only add a param if it has a value
      if (filters.states) params.state = filters.states;
      if (filters.city) params.city = filters.city;


      if (filters.plotType && filters.plotType.length > 0) {
        params['category_id[]'] = filters.plotType;
      }



      if (filters.priceRange && filters.priceRange.length === 2) {
        // send only if user changed from undefined
        params.min_price = filters.priceRange[0];
        params.max_price = filters.priceRange[1];
      }

      if (filters.areaRange && filters.areaRange.length === 2) {
        params.min_sqft = filters.areaRange[0];
        params.max_sqft = filters.areaRange[1];
      }

      if (filters.searchQuery?.trim()) params.search = filters.searchQuery.trim();




      const res = Object.keys(params).length > 0 || page > 0
        ? await get_rental_list(params, page)
        : await get_rental_list();

      setResp(res?.data);
      setYieldPlotData(res?.data?.rental || []);
      setPagination(
        res?.data?.pagination || { current_page: 1, last_page: 1 }
      );

    } catch (err) {
      setYieldPlotData([]);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchGeoPlots(filters, page);
  }, [filters, page]);


  const handlePageChange = (page) => {
    setPage(page);
    setPagination((prev) => ({ ...prev, current_page: page }));
    window.scrollTo({ top: 0, behavior: "smooth" });
    // fetchGeoPlots({}, page);
  };
  const handleFilterChange = useCallback((newFilters) => {
    setFilters(newFilters);
    setPage(1);
  }, []);
  const PropertySkeleton = () => {
    return (
      <Card
        sx={{
          borderRadius: 3,
          p: 2,
          width: "100%",
        }}
      >
        <Skeleton variant="rectangular" height={160} />
        <Skeleton height={28} sx={{ mt: 1 }} />
        <Skeleton height={20} width="80%" />
        <Skeleton height={24} width="60%" sx={{ mt: 1 }} />
      </Card>
    );
  };


  return (
    <Container sx={{ py: 5 }}>
      {/* Breadcrumb */}
      <Box sx={{ mb: 2 }}>
        <BreadcrumbsNav />
      </Box>
      {settings?.data?.gioorental_description && (
        <DescriptionNote description={settings.data.gioorental_description} />
      )}

      {/* View Toggle */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: 1.5 }}>
        <IconButton color={view === "grid" ? "primary" : "default"} onClick={() => setView("grid")}>
          <Box key={view === "grid" ? "grid-active" : "grid-idle"} component="span"
            sx={{ display: "flex", ...(view === "grid" && { animation: "iconPop 0.28s ease", "@keyframes iconPop": { "0%": { transform: "scale(0.55) rotate(-20deg)", opacity: 0.4 }, "65%": { transform: "scale(1.22)", opacity: 1 }, "100%": { transform: "scale(1) rotate(0deg)", opacity: 1 } } }) }}>
            <ViewModuleIcon />
          </Box>
        </IconButton>
        <IconButton color={view === "list" ? "primary" : "default"} onClick={() => setView("list")}>
          <Box key={view === "list" ? "list-active" : "list-idle"} component="span"
            sx={{ display: "flex", ...(view === "list" && { animation: "iconPop 0.28s ease", "@keyframes iconPop": { "0%": { transform: "scale(0.55) rotate(20deg)", opacity: 0.4 }, "65%": { transform: "scale(1.22)", opacity: 1 }, "100%": { transform: "scale(1) rotate(0deg)", opacity: 1 } } }) }}>
            <ViewListIcon />
          </Box>
        </IconButton>
      </Box>


      <Box
        sx={{
          display: { sm: "block", lg: "flex" },
          gap: 1,
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            width: { xs: "90%", sm: "60%", lg: 260 },
            mx: { xs: "auto", lg: 0 },
            flex: { lg: "0 0 260px" },
            position: { xs: "static", md: "sticky" },
            top: { lg: 110 },
            mb: { xs: 2, lg: 0 },
          }}
        >
          {/* <ResidentialFilter /> */}
          <FilterDataCard onFilterChange={handleFilterChange} isRental={true} PropertyType={resp?.name} priceMax={resp?.price_max} priceMin={resp?.price_min} stateList={resp?.state_list} />
        </Box>

        <Box
          key={view}
          sx={{
            flex: 1,
            display: "grid",
            gridTemplateColumns:
              view === "grid"
                ? {
                  xs: "1fr",
                  sm: "1fr 1fr",
                  md: "1fr 1fr",
                  lg: "1fr 1fr",
                }
                : {
                  xs: "1fr",
                  sm: "1fr",
                  md: "1fr",
                  lg: "1fr",
                },
            gap: { xs: 1.5, md: 2 },
            ml: { xs: 0, lg: 6 },
            mt: { xs: 2, lg: 0 },
            px: 2,
            py: 2,
            "& > *": { height: "100%" },
            // container entrance
            animation: "viewEnter 0.35s cubic-bezier(0.34,1.2,0.64,1) both",
            "@keyframes viewEnter": {
              "0%": { opacity: 0, transform: "scale(0.97) translateY(14px)" },
              "60%": { opacity: 1, transform: "scale(1.005) translateY(-2px)" },
              "100%": { opacity: 1, transform: "scale(1) translateY(0)" },
            },
            // stagger each direct child card
            "& > *": {
              animation: "cardSlideIn 0.42s cubic-bezier(0.34,1.2,0.64,1) both",
              height: "100%",
              "@keyframes cardSlideIn": {
                "0%": { opacity: 0, transform: "translateY(20px) scale(0.96)" },
                "70%": { opacity: 1, transform: "translateY(-3px) scale(1.01)" },
                "100%": { opacity: 1, transform: "translateY(0) scale(1)" },
              },
            },
            "& > *:nth-of-type(1)": { animationDelay: "0.04s" },
            "& > *:nth-of-type(2)": { animationDelay: "0.09s" },
            "& > *:nth-of-type(3)": { animationDelay: "0.14s" },
            "& > *:nth-of-type(4)": { animationDelay: "0.19s" },
            "& > *:nth-of-type(5)": { animationDelay: "0.24s" },
            "& > *:nth-of-type(6)": { animationDelay: "0.29s" },
            "& > *:nth-of-type(n+7)": { animationDelay: "0.32s" },
          }}
        >
          {loading ? (
            Array.from(new Array(6)).map((_, index) => (
              <PropertySkeleton key={index} />
            ))
          ) : yieldplotData.length > 0 ? (
            yieldplotData.map((rental) =>
              view === "grid" ? (


                <RentalYieldGridView
                  key={rental.id}
                  id={rental.id}
                  name={rental.name}
                  totalamount={rental.total_price}
                  address={rental.address}
                  images={Array.isArray(rental.files) ? rental.files : []}
                  nearby={rental.nearby_locations || []}
                  amenities={rental.amenity || []}
                  persqft={rental.price_per_sqft}
                  description={rental.overview}
                  verify={rental?.verify_status}
                  area={rental?.area}
                  soldStatus={rental?.sold_status}
                />

              ) : (
                <RentalYieldCard
                  key={rental.id}
                  id={rental.id}
                  name={rental.name}
                  totalamount={rental.total_price}
                  address={rental.address}
                  images={Array.isArray(rental.files) ? rental.files : []}
                  nearby={rental.nearby_locations || []}
                  amenities={rental.amenity || []}
                  persqft={rental.price_per_sqft}
                  description={rental.overview}
                  verify={rental?.verify_status}
                  area={rental?.area_sqft}
                  soldStatus={rental?.sold_status}
                />
              )
            )
          ) : (
            <Box
              sx={{
                gridColumn: "1 / -1",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "60vh",
                textAlign: "center",
                width: "100%",
                py: 5,
              }}
            >
              <Box
                component="img"
                src="/assets/images/nodatafound.png"
                alt="No Data Found"
                sx={{ width: { xs: 320, sm: 350, md: 380 }, mb: 2 }}
              />
            </Box>
          )}

        </Box>
      </Box>

      {/* ================= PAGINATION ================= */}

      {yieldplotData.length > 0 && pagination.last_page > 1 && <Stack direction="row" spacing={1} justifyContent="center" mt={5}>
        {Array.from({ length: pagination.last_page }, (_, i) => i + 1).map(
          (page) => (
            <Button
              key={page}
              variant={
                page === pagination.current_page ? "contained" : "outlined"
              }
              onClick={() => handlePageChange(page)}
            >
              {page}
            </Button>
          )
        )}
      </Stack>}
    </Container>
  );
}
